export default __webpack_public_path__ + "static/media/t7.min.e09f6ad4.png";